const SectionDivider = () => {
  return (
    <div data-reveal className="container-narrow py-0">
      <div className="flex items-center gap-4">
        <div className="flex-1 h-px bg-border" />
        <div className="w-2.5 h-2.5 rotate-45 bg-primary opacity-60" />
        <div className="flex-1 h-px bg-border" />
      </div>
    </div>
  );
};

export default SectionDivider;
